// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__Sz_d3","label":"Input_label__RfGA8","labelText":"Input_labelText__ZZcaV","error":"Input_error__Nqe_D"};